import apiSportsObjects from '@/api/sports-objects'

const state = {
  isLoading: false,
  sportsObjects: [],
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  getSportObjectsStart: '[sportsObjects] getSportObjectsStart',
  getSportObjectsSuccess: '[sportsObjects] getSportObjectsSuccess',
  getSportObjectsFailure: '[sportsObjects] getSportObjectsFailure',

  addSportObjectsStart: '[create sports Objects] create Sport Objects Start',
  addSportObjectsSuccess: '[create sports Objects] create Sport ObjectsSuccess',
  addSportObjectsFailure: '[create sports Objects] create Sport Objects Failure'
}

export const actionType = {
  getSportObjects: '[sportsObjects] getSportObjects',
  addSportObjects: '[sportsObjects] addSportObjects'
}

const mutations = {
  [mutationTypes.getSportObjectsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportObjectsSuccess](state, payload) {
    state.isLoading = false
    state.sportsObjects = payload
  },

  [mutationTypes.getSportObjectsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.addSportObjectsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addSportObjectsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addSportObjectsFailure](state) {
    state.isSubmitting = false
  }
}

const actions = {
  [actionType.getSportObjects](context) {
    context.commit(mutationTypes.getSportObjectsStart)
    return new Promise(resolve => {
      apiSportsObjects
        .getSportObjects()
        .then(response => {
          context.commit(mutationTypes.getSportObjectsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.getSportObjectsFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.addSportObjects](context, sport) {
    context.commit(mutationTypes.addSportObjectsStart)
    return new Promise(resolve => {
      apiSportsObjects
        .addSportObjects(sport)
        .then(response => {
          context.commit(mutationTypes.addSportObjectsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.addSportObjectsFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
